import IpsModal from './IpsModal.vue';
import '../../../styles/custom.scss';

export default IpsModal;
